/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SignInDto
 */
export interface SignInDto {
    /**
     * AuthテナントID
     * @type {string}
     * @memberof SignInDto
     */
    authTenantId: string;
    /**
     * メールアドレス
     * @type {string}
     * @memberof SignInDto
     */
    email: string;
    /**
     * パスワード
     * @type {string}
     * @memberof SignInDto
     */
    password: string;
}

/**
 * Check if a given object implements the SignInDto interface.
 */
export function instanceOfSignInDto(value: object): value is SignInDto {
    if (!('authTenantId' in value) || value['authTenantId'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    return true;
}

export function SignInDtoFromJSON(json: any): SignInDto {
    return SignInDtoFromJSONTyped(json, false);
}

export function SignInDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignInDto {
    if (json == null) {
        return json;
    }
    return {
        
        'authTenantId': json['authTenantId'],
        'email': json['email'],
        'password': json['password'],
    };
}

export function SignInDtoToJSON(json: any): SignInDto {
    return SignInDtoToJSONTyped(json, false);
}

export function SignInDtoToJSONTyped(value?: SignInDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'authTenantId': value['authTenantId'],
        'email': value['email'],
        'password': value['password'],
    };
}

